<template>
  <div class="flex w-full h-full bg-gray-800 overflow-y-auto">
    <PortalTarget class="absolute right-4" name="deck-grid-view-notification" />
    <PortalTarget class="w-full" name="deck-grid-view" />
  </div>
</template>
